<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-titlec" id="lev_10">Chronology of the Bourbon Era</h2>
<table>
<tbody><tr>
<td class="tab01">1700</td>
<td class="tab01">1 Nov</td>
<td class="tab01">Death of Carlos II, the last Habsburg King of Spain, without heirs.</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">16 Nov</td>
<td class="tab01">Proclamation (in Versailles) of Philippe d’Anjou as Felipe V of Spain.</td>
</tr>
<tr>
<td class="tab01">1701</td>
<td class="tab01">15 May</td>
<td class="tab01">Declaration of War by the Grand Alliance began War of the Spanish Succession.</td>
</tr>
<tr>
<td class="tab01">1702</td>
<td class="tab01">23 Oct</td>
<td class="tab01">Battle of Vigo.</td>
</tr>
<tr>
<td class="tab01">1704</td>
<td class="tab01">23 July</td>
<td class="tab01">English capture of Gibraltar.</td>
</tr>
<tr>
<td class="tab01">1713</td>
<td class="tab01">9 Dec</td>
<td class="tab01">Treaty of Utrecht ended war between Spain and Britain.</td>
</tr>
<tr>
<td class="tab01">1718</td>
<td class="tab01">11 Aug</td>
<td class="tab01">Battle of Cape Passaro (off south-east coast of Sicily).</td>
</tr>
<tr>
<td class="tab01">1724</td>
<td class="tab01">15 Jan</td>
<td class="tab01">Abdication of Felipe V, and accession of his son Luis.</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">6 Sept</td>
<td class="tab01">Death of Luis, and restoration of Felipe V.</td>
</tr>
<tr>
<td class="tab01">1740</td>
<td class="tab01">8 Apr</td>
<td class="tab01">Action off Cape Finisterre.</td>
</tr>
<tr>
<td class="tab01">1744</td>
<td class="tab01">22 Feb</td>
<td class="tab01">Battle of Cape Sicié (also called Battle of Toulon).</td>
</tr>
<tr>
<td class="tab01">1746</td>
<td class="tab01">9 July</td>
<td class="tab01">Death of Felipe V, and accession of his fourth son, Fernando VI.</td>
</tr>
<tr>
<td class="tab01">1748</td>
<td class="tab01">12 Oct</td>
<td class="tab01">Action off Havana.</td>
</tr>
<tr>
<td class="tab01">1759</td>
<td class="tab01">10 Aug</td>
<td class="tab01">Death of Fernando VI, and accession of his half-brother, Carlos III (fifth son of Felipe V).</td>
</tr>
<tr>
<td class="tab01">1762</td>
<td class="tab01">Mar</td>
<td class="tab01">Siege of Havana (to May).</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">24 Sept</td>
<td class="tab01">Battle of Manila (to 6 Oct).</td>
</tr>
<tr>
<td class="tab01">1780</td>
<td class="tab01">16 Jan</td>
<td class="tab01">2nd Battle of Cape St Vincent (Rodney’s ‘Moonlight battle’), also called the Battle of Cape Santa María in Spanish.</td>
</tr>
<tr>
<td class="tab01">1780</td>
<td class="tab01">20 Oct</td>
<td class="tab01">Battle of Cape Spartel.</td>
</tr>
<tr>
<td class="tab01">1788</td>
<td class="tab01">14 Dec.</td>
<td class="tab01">Death of Carlos III, and accession of his son, Carlos IV.</td>
</tr>
<tr>
<td class="tab01">1793</td>
<td class="tab01">27 Aug</td>
<td class="tab01">Anglo-Spanish Occupation of Toulon.</td>
</tr>
<tr>
<td class="tab01">1797</td>
<td class="tab01">14 Feb</td>
<td class="tab01">3rd Battle of Cape St Vincent</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">17 Feb</td>
<td class="tab01">Action in Chaguaramas Bay (Trinidad)</td>
</tr>
<tr>
<td class="tab01">1801</td>
<td class="tab01">12 July</td>
<td class="tab01">Action off Gibraltar (Battle of Algeciras Bay)</td>
</tr>
<tr>
<td class="tab01">1805</td>
<td class="tab01">22 July</td>
<td class="tab01">Battle of Cape Finisterre (‘Calder’s Action’).</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">22 Oct</td>
<td class="tab01">Battle of Cape Trafalgar.</td>
</tr>
<tr>
<td class="tab01">1808</td>
<td class="tab01">19 Mar</td>
<td class="tab01">First abdication of Carlos IV, and accession of his son Fernando VII.</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">2 May</td>
<td class="tab01">Uprising of Madrid against the French occupation starts war against France (to Apr 1814).</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">5 May</td>
<td class="tab01">‘Abdication’ (enforced) of Fernando VII, and temporary restoration of Carlos IV.</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">6 May</td>
<td class="tab01">Second abdication of Carlos IV, with throne ceded to Napoleon.</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">6 June</td>
<td class="tab01">Appointment (by Napoleon) of his brother Joseph Bonaparte as (King) José.</td>
</tr>
<tr>
<td class="tab01">1813</td>
<td class="tab01">11 Dec</td>
<td class="tab01">Deposition of José, and restoration of Fernando VII.</td>
</tr>
<tr>
<td class="tab01">1833</td>
<td class="tab01">29 Sept</td>
<td class="tab01">Death of Fernando VII, and accession of his daughter, Isabel II.</td>
</tr>
<tr>
<td class="tab01">1833</td>
<td class="tab01"></td>
<td class="tab01">Start of 1st Carlist War between absolutists and liberals (to 1840).</td>
</tr>
<tr>
<td class="tab01">1846</td>
<td class="tab01"></td>
<td class="tab01">2nd Carlist War (to 1849).</td>
</tr>
<tr>
<td class="tab01">1865</td>
<td class="tab01"></td>
<td class="tab01">Start of Spanish-South American War (or ‘Chincha Islands War’) between Spain and her former colonies of Chile, Peru, Ecuador and Bolivia.</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">26 Nov</td>
<td class="tab01">Battle of Papupo (between Spain’s <em class="italic">Covadonga</em> and Chile’s <em class="italic">Esmeralda</em>)</td>
</tr>
<tr>
<td class="tab01">1866</td>
<td class="tab01">2 Feb</td>
<td class="tab01">Battle of Abtao between 2 Spanish frigates and an Allied (Chilean-Peruvian) squadron.</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">31 Mar</td>
<td class="tab01">Bombardment of Valparaiso by Spanish squadron destroyed 33 Chilean merchant ships.</td>
</tr>
<tr>
<td class="tab01"></td>
<td class="tab01">2 May</td>
<td class="tab01">Attack on Callao (Chile) by Spanish squadron.</td>
</tr>
<tr>
<td class="tab01">1868</td>
<td class="tab01">30 Sept</td>
<td class="tab01">Deposition of Isabel II, and Regency of General Francisco Serrano y Domínguez.</td>
</tr>
<tr>
<td class="tab01">1870</td>
<td class="tab01">16 Nov</td>
<td class="tab01">‘Election’ of Amadeo (of House of Savoy-Carignano) as King.</td>
</tr>
<tr>
<td class="tab01">1872</td>
<td class="tab01"></td>
<td class="tab01">3rd Carlist War (to 1876)</td>
</tr>
<tr>
<td class="tab01">1873</td>
<td class="tab01">11 Feb</td>
<td class="tab01">Abdication of Amadeo, and establishment of First Republic of Spain.</td>
</tr>
<tr>
<td class="tab01">1874,</td>
<td class="tab01">29 Dec</td>
<td class="tab01">Restoration of House of Bourbon under Alfonso XII, son of Isabel II.</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Chronology1.vue?51319561